import { getContext } from '@fiverr-private/fiverr_context';
import { URL_TARGET } from './constants';

export const buildContextEnrichment = ({ currency, pageContext, sourceComponent, isTouch }) => {
    const { pageCtxId, userId } = getContext();

    return {
        context: {
            userId,
            pageCtxId,
            currency,
            sourceComponent,
            isTouch,
            ...pageContext,
        },
        urlTarget: URL_TARGET,
    };
};
